import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2619851f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "button-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-camera" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "float-right text-muted mt-2 mb-1 mr-2" }
const _hoisted_9 = { class: "h5 mb-1 mt-1" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = {
  key: 0,
  width: "15%"
}
const _hoisted_13 = {
  key: 1,
  width: "5%"
}
const _hoisted_14 = {
  key: 2,
  width: "7%"
}
const _hoisted_15 = { width: "23%" }
const _hoisted_16 = { class: "table table-sm table-borderless" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_19 = { width: "90%" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"padding-top":"5px"} }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 3,
  width: "50%"
}
const _hoisted_27 = {
  key: 0,
  class: "table table-sm table-borderless"
}
const _hoisted_28 = {
  key: 4,
  width: "50%"
}
const _hoisted_29 = {
  key: 0,
  class: "table table-sm table-borderless"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "float-right text-danger"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-flag" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, null, -1))
const _hoisted_42 = { key: 0 }

import _isEmpty from "lodash/isEmpty";
import ContentEditable from '../ContentEditable.vue';
import ConditionResponsibilities from "@/components/report/ConditionResponsibilities.vue";
import ConditionSameAsCheckIn from "@/components/report/ConditionSameAsCheckIn.vue";
import Photos from '@/components/photo/Photos.vue';

import { ref, PropType, nextTick, toRefs, computed, inject, provide, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import _get from 'lodash/get';
import { Condition, Item, Maintenanceflag, Note, Report } from '@/models';
import { ReportsState } from '@/store/reports/types';


// Injects

export default /*#__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
  index: {type: Number, default: -1},
  item: {type: Object as PropType<Item>, default: new Item},
},
  setup(__props, { expose: __expose }) {

const roomIndex = inject<number>('roomIndex')!;
const sectionIndex = inject<number>('sectionIndex')!;
const typeIndex = inject<number>('typeIndex')!;
const typeName = inject<string>('typeName')!;
const typeSlug = inject<string>('typeSlug')!;

const props = __props;

provide('itemIndex', props.index);

const store = useStore();
const actProperty: any = inject('actProperty');
const instance = getCurrentInstance();

const reportsState = computed(() => store.state.reports as ReportsState);

// Convert props to refs
const { index, item } = toRefs(props);
provide("itemIndex", index?.value);

const currentReportItems = computed((): Item[] => store.getters['reports/currentReportItems']);
const itemNumber = (item: Item): number => {
  return currentReportItems.value.findIndex((x: Item) => x._uuid === item._uuid) + 1;
};

const maintenanceflags = computed((): Maintenanceflag[] => store.getters['customerdictionary/maintenanceflags']);

const setReport = (report: Report): Promise<any> => {
  return store.dispatch('reports/setReport', report)
}

const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload)
}

const removeFromRooms = (payload: {
    roomIndex: number;
    sectionIndex: number;
    typeIndex: number;
    itemIndex: number;
    inOrOut?: string;
    noteIndex?: number;
  }): Promise<any> => {
  return store.dispatch('reports/removeFromRooms', payload)
}

const showPhotos = ref(true);
const dynamicRefs = ref({});
dynamicRefs.value = {'in-notes': [], 'out-notes': []};

const report = computed({
  get: (): Report => reportsState.value.current,
  set: (data: Report) => {
    setReport(data).then(() => {
    nextTick(() => {
      console.log("Updated Item");
    });
  });
  }
});


/**
 * Hide/show images
 */
const hideImages = (): void => {
  showPhotos.value = !showPhotos.value;
}

/**
 * Generate hashes from objects
 */
const getHash = (obj: any, index: number) => {
  return `${index}-${actProperty.hashObj([obj, index])}`;
}

/**
 * Check if report type is Check-Out
 */
const isCheckOut = () => {
  return report.value.type == "checkout";
}

const getMaintenanceButtonStyle = (maintenanceflag: Maintenanceflag) => {
  let style = "";
  if (
    item?.value &&
    item?.value.condition &&
    item?.value.condition.responsibility
  ) {
    if (Array.isArray(item?.value.condition.responsibility)) {
      style += item?.value.condition.responsibility.includes(
        maintenanceflag.flag
      )
        ? "background-color: " + maintenanceflag.colour
        : "";
    } else {
      actProperty.displayError(
        Error(
          `The Note Responsibility is not an array: ${JSON.stringify(
            item?.value.condition.responsibility
          )}`
        )
      );
    }
  }
  return style;
}

const setMaintenanceflag = (maintenanceflag: Maintenanceflag) => {
  if (item?.value) {
    if (!item?.value.condition) {
      item.value.condition = {
        responsibility: [],
        previousresponsibility: [],
        in: new Condition(),
        out: new Condition(),
      };
    }
    // Toggle flag if it is already selected
    if (item?.value.condition.responsibility[0] === maintenanceflag.flag)
      item.value.condition.responsibility[0] = "";
    else item.value.condition.responsibility[0] = maintenanceflag.flag;
    setReportDeep({
      path: getItemPath(`condition`),
      data: item?.value.condition,
    });
  }
}

/**
 * Returns boolean value if condition out notes contains responsibilities
 *
 * @param {Item} item
 */
const hasResponsibilities = (item: Item): boolean => {
  return item.condition.out.notes.some(
    (note: Note) => false === _isEmpty(note.responsibility)
  );
}

/**
 * Remove Item from Room
 */
const remove = () => {
  actProperty.confirmPrompt().then(() =>
    removeFromRooms({
      roomIndex: roomIndex,
      sectionIndex: sectionIndex,
      typeIndex: typeIndex,
      itemIndex: index.value,
    })
  );
}

/**
 * Returns Selected Class Name
 *
 * @param {String} responsibility
 * @param {Note} note
 */
const responsibilitySelectedClassName = (responsibility: string, note: Note) => {
  let className = "";

  if (note.responsibility === undefined) {
    note.responsibility = [];
  } else if (Array.isArray(note.responsibility)) {
    className =
      note.responsibility.indexOf(responsibility) > -1 ? "selected" : "";
  } else if (typeof note.responsibility === "string") {
    className = note.responsibility === responsibility ? "selected" : "";
    note.responsibility = [note.responsibility];
  }

  return className;
}

/**
 * Returns Active Item Path
 */
const getItemPath = (append: string) => {
  if (append) {
    append = `.${append}`;
  }
  return `rooms[${roomIndex}].sections[${sectionIndex}].types[${typeIndex}].items[${index?.value}]${append}`;
}

/**
 * Return Check-In Photos from Items
 *
 * @param {Item} item
 */
const getInPhotos = (item: Item) => {
  return _get(item, "condition.in.photos", []);
}
const inPhotoCount = (item: Item) => {
  const photos = _get(item, "condition.in.photos", []);
  return photos.length;
}

/**
 * Return Check-Out Photos from Items
 *
 * @param {Item} item
 */
const getOutPhotos = (item: Item) => {
  return _get(item, "condition.out.photos", []);
}
const outPhotoCount = (item: Item) => {
  const photos = _get(item, "condition.out.photos", []);
  return photos.length;
}

/**
 * Some special stuff is required here cos we are using contenteditable.
 */
const setCaret = (el: any) => {
  if (!el) {
    return;
  }

  const selection = window.getSelection();

  if (selection) {
    selection.removeAllRanges();
  }

  const range = document.createRange();

  range.selectNodeContents(el);

  // if (el.firstChild) {
  //   range.setStart(el.firstChild, el.innerText.length);
  //   range.setEnd(el.firstChild, el.innerText.length);
  // } else {
  //   range.setStart(el, el.innerText.length);
  //   range.setEnd(el, el.innerText.length);
  // }

  if (selection) {
    selection.addRange(range);
  }
}

/**
 *  Place cursor at the end of given ediable div element
 */
const setCursorAtEnd = (el: any) => {
  if (!el) {
    return;
  }

  const range = document.createRange();
  const selection = window.getSelection();
  if (selection) {
    selection.removeAllRanges();
  }

  if (el.firstChild) {
    range.setStart(el.firstChild, el.firstChild.length);
  } else {
    range.setStart(el, 0);
  }
  range.collapse(true);
  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

/**
 * Add New Condition Note to a Room
 *
 * @param {String} inOrOut
 * @param {Number} noteIndex
 */
const insertNote = (inOrOut: string, noteIndex: number, event: any) => {
  const notes: Note[] = _get(item?.value, `condition[${inOrOut}].notes`, []);

  let insertAtIndex = 0;

  if (typeof noteIndex === "number") {
    insertAtIndex = noteIndex + 1;
  }

  const note = new Note();

  let cursorPos = -1;
  let selection: Selection | null = window.getSelection();
  if (selection) {
    cursorPos = selection.anchorOffset;
  }

  if (notes.length > noteIndex) {
    let currentNote = notes[noteIndex];
    let currentNoteValue = event.currentTarget.innerText;
    if (
      currentNoteValue &&
      cursorPos >= 0 &&
      currentNoteValue.length > cursorPos
    ) {
      let contentsBeforeCursor = currentNoteValue.substring(0, cursorPos);
      let contentsAfterCursor = currentNoteValue.substring(
        cursorPos,
        currentNoteValue.length
      );
      currentNote.note = contentsBeforeCursor;
      note.note = contentsAfterCursor;
      const ref = dynamicRefs.value[`${inOrOut}-notes`][noteIndex] as any;
      if (ref) {
        ref.$el.innerHTML = contentsBeforeCursor;
      }
    }
  }

  notes.splice(insertAtIndex, 0, note);

  setReportDeep({
    path: getItemPath(`condition[${inOrOut}].notes`),
    data: notes,
  })
    .then(() => instance?.proxy?.$forceUpdate())
    .then(() =>
      nextTick(() => {
        const ref = dynamicRefs.value[`${inOrOut}-notes`][insertAtIndex] as any;
        if (ref) {
          setCursorAtEnd(ref.$el);
        }
      })
    );
}

/**
 * Update Condition Note
 *
 * @param {String} inOrOut
 * @param {Number} noteIndex
 * @param {$event}
 */
const updateNote = (inOrOut: string, noteIndex: number, $event: any) => {
  const notes: Note[] = _get(item?.value, `condition[${inOrOut}].notes`, []);
  let currentNote = notes[noteIndex];
  if (!currentNote?.originalnote) {
    let onote = currentNote?.note;
    if (!onote) {
      onote = " ";
    }
    setReportDeep({
      path: getItemPath(
        `condition[${inOrOut}].notes[${noteIndex}].originalnote`
      ),
      data: onote,
    }).then(() => instance?.proxy?.$forceUpdate());
  }
  setReportDeep({
    path: getItemPath(`condition[${inOrOut}].notes[${noteIndex}].note`),
    data: $event,
  }).then(() => instance?.proxy?.$forceUpdate());
}

/**
 * Flag Note for feedback by QC
 */
const toggleNotesFlagged = (
  inOrOut: string,
  noteIndex: number,
  note: Note
): void => {
  note.flagged = !note.flagged;
  setReportDeep({
    path: getItemPath(
      `condition[${inOrOut}].notes[${noteIndex}].flagged`
    ),
    data: note.flagged,
  }).then(() => instance?.proxy?.$forceUpdate());
}

/**
 * Delete Condition Note from Rooms
 *
 * @param {String} inOrOut
 * @param {Number} noteIndex
 */
const deleteNote = (inOrOut: string, noteIndex: number) => {
  removeFromRooms({
    roomIndex: roomIndex,
    sectionIndex: sectionIndex,
    typeIndex: typeIndex,
    itemIndex: index.value,
    inOrOut,
    noteIndex,
  })
    .then(() => instance?.proxy?.$forceUpdate())
    .then(() =>
      nextTick(() => {
        const refs = dynamicRefs.value[`${inOrOut}-notes`] as any[];
        if (refs.length) {
          if (noteIndex > 0) {
            setCursorAtEnd(refs[noteIndex - 1].$el);
          } else {
            setCursorAtEnd(refs[0].$el);
          }
        }
      })
    );
}

/**
 * Return boolean value if SACI button is active
 */
const isSameAsCheckIn = (): boolean => {
  return _get(item?.value, "condition.out.sameAsCheckin.active", false);
}

/**
 * Return 'Same as Check-In' String in CO Notes
 */
const saciNote = computed((): string => {
  return _get(
    item.value,
    "condition.out.sameAsCheckin.note.note",
    "Same as Check-In"
  );
});

/**
 * Returns Check-In Condition Notes
 */
const getConditionInNotes = () => {
  const notes = _get(item.value, "condition.in.notes", false);
  if (notes === false) {
    return [];
  }
  return notes;
}

/**
 * Returns Check-Out Condition Notes
 */
const getConditionOutNotes = () => {
  const notes = _get(item.value, "condition.out.notes", false);
  if (notes === false) {
    return [];
  }
  return notes;
}

__expose({dynamicRefs});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card bg-white",
    id: `item-${_unref(item)._uuid}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hideImages())),
          class: "btn btn-sm btn-outline-info"
        }, _hoisted_5),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (remove())),
          class: "btn btn-sm btn-outline-danger"
        }, _hoisted_7)
      ]),
      _createElementVNode("code", _hoisted_8, _toDisplayString(_unref(typeSlug)), 1),
      _createElementVNode("h4", _hoisted_9, _toDisplayString(itemNumber(_unref(item))) + ". " + _toDisplayString(_unref(typeName)), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (
                !_unref(actProperty).isFactoryreport(report.value.type) || _unref(item).locallyadded
              )
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  _createVNode(ContentEditable, {
                    content: _unref(item).name,
                    multiline: true,
                    onUpdate: _cache[2] || (_cache[2] = ($event: any) => (
                  setReportDeep({
                    path: getItemPath('name'),
                    data: $event,
                  })
                ))
                  }, null, 8, ["content"])
                ]))
              : _createCommentVNode("", true),
            (!_unref(actProperty).isFactoryreport(report.value.type))
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                  _createVNode(ContentEditable, {
                    content: _unref(item).qty,
                    integer: true,
                    onUpdate: _cache[3] || (_cache[3] = ($event: any) => (
                  setReportDeep({
                    path: getItemPath('qty'),
                    data: $event,
                  })
                ))
                  }, null, 8, ["content"])
                ]))
              : _createCommentVNode("", true),
            (!_unref(actProperty).isFactoryreport(report.value.type))
              ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                  _createVNode(ContentEditable, {
                    content: _unref(item).colour,
                    onUpdate: _cache[4] || (_cache[4] = ($event: any) => (
                  setReportDeep({
                    path: getItemPath('colour'),
                    data: $event,
                  })
                ))
                  }, null, 8, ["content"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                (!getConditionInNotes().length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (insertNote('in', 0, $event))),
                        class: "btn btn-sm btn-outline-secondary"
                      }, [
                        _hoisted_18,
                        _createTextVNode(" Note ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConditionInNotes(), (note, $noteIndex) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: note._uuid
                  }, [
                    _createElementVNode("td", _hoisted_19, [
                      _createVNode(ContentEditable, {
                        ref_for: true,
                        ref: el => { dynamicRefs.value['in-notes'][$noteIndex] = el },
                        content: note.note,
                        "data-uuid": note._uuid,
                        onInsert: ($event: any) => (insertNote('in', $noteIndex, $event)),
                        onUpdate: ($event: any) => (updateNote('in', $noteIndex, $event)),
                        onDelete: ($event: any) => (deleteNote('in', $noteIndex))
                      }, null, 8, ["content", "data-uuid", "onInsert", "onUpdate", "onDelete"])
                    ]),
                    _createElementVNode("td", null, [
                      (
                        !_unref(actProperty).isFactoryreport(report.value.type) &&
                        note.originalnote &&
                        note.originalnote != note.note
                      )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (toggleNotesFlagged('in', $noteIndex, note)),
                            class: _normalizeClass(["btn btn-sm btn-outline-secondary no-border", {
                        flaggednote: note.flagged,
                      }])
                          }, _hoisted_22, 10, _hoisted_20))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                (_unref(actProperty).isFactoryreport(report.value.type))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                      _createElementVNode("td", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maintenanceflags.value, (maintenanceflag) => {
                          return (_openBlock(), _createElementBlock("button", {
                            class: "btn btn-light maintenanceflagbutton",
                            key: maintenanceflag.slug,
                            style: _normalizeStyle(getMaintenanceButtonStyle(maintenanceflag)),
                            onClick: ($event: any) => (setMaintenanceflag(maintenanceflag))
                          }, _toDisplayString(maintenanceflag.flag), 13, _hoisted_25))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!isCheckOut())
              ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                  (showPhotos.value)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                        (_openBlock(), _createBlock(Photos, {
                          key: `item${_unref(item)._uuid}in${inPhotoCount(_unref(item))}`,
                          photos: getInPhotos(_unref(item)),
                          path: getItemPath('condition.in.photos')
                        }, null, 8, ["photos", "path"]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isCheckOut())
              ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                  (isCheckOut())
                    ? (_openBlock(), _createElementBlock("table", _hoisted_29, [
                        _createElementVNode("tr", null, [
                          _createVNode(ConditionSameAsCheckIn)
                        ]),
                        (isSameAsCheckIn())
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                              _createElementVNode("td", null, [
                                _createVNode(ContentEditable, {
                                  content: saciNote.value,
                                  onUpdate: _cache[6] || (_cache[6] = ($event: any) => (
                        setReportDeep({
                          path: getItemPath(
                            'condition.out.sameAsCheckin.note.note'
                          ),
                          data: $event,
                        })
                      ))
                                }, null, 8, ["content"])
                              ]),
                              _hoisted_31,
                              _createElementVNode("td", null, [
                                _createVNode(ConditionResponsibilities, {
                                  "note-path": 
                        getItemPath('condition.out.sameAsCheckin.note')
                      
                                }, null, 8, ["note-path"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!getConditionOutNotes().length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                              _createElementVNode("button", {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (insertNote('out', 0, $event))),
                                class: "btn btn-sm btn-outline-secondary"
                              }, [
                                _hoisted_33,
                                _createTextVNode(" Note ")
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConditionOutNotes(), (note, $noteIndex) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: note._uuid
                          }, [
                            _createElementVNode("td", null, [
                              _createVNode(ContentEditable, {
                                ref_for: true,
                                ref: el => { dynamicRefs.value['out-notes'][$noteIndex] = el },
                                content: note.note,
                                "data-uuid": note._uuid,
                                onInsert: ($event: any) => (insertNote('out', $noteIndex, $event)),
                                onUpdate: ($event: any) => (updateNote('out', $noteIndex, $event)),
                                onDelete: ($event: any) => (deleteNote('out', $noteIndex))
                              }, null, 8, ["content", "data-uuid", "onInsert", "onUpdate", "onDelete"])
                            ]),
                            _createElementVNode("td", null, [
                              (note.originalnote && note.originalnote != note.note)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (toggleNotesFlagged('out', $noteIndex, note)),
                                    class: _normalizeClass(["btn btn-sm btn-outline-secondary no-border", {
                        flaggednote: note.flagged,
                      }])
                                  }, _hoisted_36, 10, _hoisted_34))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(ConditionResponsibilities, {
                                "note-path": 
                        getItemPath(`condition.out.notes[${$noteIndex}]`)
                      
                              }, null, 8, ["note-path"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (
                  isCheckOut() && report.value.flagged && hasResponsibilities(_unref(item))
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (isCheckOut() && showPhotos.value)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("td", null, [
                  (_openBlock(), _createBlock(Photos, {
                    key: `item${_unref(item)._uuid}in${_unref(item).condition.in.photos.length}`,
                    photos: getInPhotos(_unref(item)),
                    path: getItemPath('condition.in.photos')
                  }, null, 8, ["photos", "path"]))
                ]),
                _createElementVNode("td", null, [
                  (isCheckOut())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        (_openBlock(), _createBlock(Photos, {
                          key: `item${_unref(item)._uuid}out${outPhotoCount(_unref(item))}`,
                          photos: getOutPhotos(_unref(item)),
                          path: getItemPath('condition.out.photos')
                        }, null, 8, ["photos", "path"]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})